export var RoleType = /*#__PURE__*/function (RoleType) {
  RoleType["Role"] = "ROLE";
  RoleType["Person"] = "PERSON";
  return RoleType;
}({});